// Static seat layout for the Irish Office 1st Floor.
// Seat assignments themselves (which user sits where) are stored server-side
// via the floor_plan_seats API - this file only describes the physical layout.
//
// Each "group" is a desk block rendered as its own bordered box, made up of
// `rows` sub-rows of seats (back-to-back desks), matching the floor plan.

export function seatBlock(prefix, groupIndex, rowCount, colCount) {
    const rows = [];
    for (let r = 1; r <= rowCount; r++) {
        rows.push(
            Array.from({ length: colCount }, (_, i) => ({
                key: `${prefix}-${groupIndex}-${r}-${i + 1}`,
                label: `${prefix.toUpperCase()}${groupIndex}-${r}.${i + 1}`,
            }))
        );
    }
    return rows;
}

// Top-right cluster: single 2x2 block (4 seats)
export const topRightCluster = seatBlock('tr', 1, 2, 2);

// Left column: 4 blocks, each 2 rows x 4 cols = 8 seats per block
export const leftGroups = [
    seatBlock('l', 1, 2, 4),
    seatBlock('l', 2, 2, 4),
    seatBlock('l', 3, 2, 4),
];

// Right column (below the top-right cluster): 3 blocks, each 2 rows x 3 cols = 6 seats per block
export const rightGroups = [
    seatBlock('r', 1, 2, 3),
    seatBlock('r', 2, 2, 3),
];

// Gers Office and Deans Office are single-occupant seats, not plain seat blocks.
export const gersOfficeSeat = { key: 'o-office-gers', label: "Ger's Office" };
export const deansOfficeSeat = { key: 'o-office-deans', label: "Dean's Office" };

// Two tall single-occupant seats sitting in the gap to the left of each
// rightGroups block.
export const rightExtraSeats = [
    { key: 're-1', label: 'RE1' },
    { key: 're-2', label: 'RE2' },
];

export const allSeats = [
    ...topRightCluster.flat(),
    ...leftGroups.flat(2),
    ...rightGroups.flat(2),
    gersOfficeSeat,
    deansOfficeSeat,
    ...rightExtraSeats,
];

// Roughly locates a seat key within the layout so unit bubbles can be placed
// near the side/vertical area where that unit's seats actually are.
export function parseSeatKey(seatKey) {
    const [prefix, group] = seatKey.split('-');
    const groupIndex = Number(group) || 0;
    if (prefix === 'l') return { side: 'left', groupIndex };
    if (prefix === 'r') return { side: 'right', groupIndex };
    if (prefix === 're') return { side: 'right', groupIndex };
    if (prefix === 'tr') return { side: 'right', groupIndex: 0 };
    return { side: 'left', groupIndex: 0 };
}
